(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('IdmStatiGenerali', IdmStatiGenerali);

    IdmStatiGenerali.$inject = ['$resource'];

    function IdmStatiGenerali ($resource) {
        var resourceUrl =  'api/stati-generali/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'macroStati': { url: 'api/macro-stati', method: 'GET', isArray: true},
            'ruoli': { url: 'api/ruoli-categorie', method: 'GET', isArray: true},
            'allStati': { url: 'api/stati', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
